import { buildSort, goPromise } from "@delanobgt/admin-core/util/helpers";
import {
  ApiClientFactory,
  IMeta,
  IPagination,
  ISort,
} from "@delanobgt/admin-core/util/types";
import { CancelTokenSource } from "axios";
import _ from "lodash";

import {
  EConsignmentSortField,
  IConsignment,
  PConsignmentFilter,
} from "../entities";
import IConsignmentRepository from "../repository";

export default class ConsignmentRepository
  implements IConsignmentRepository<CancelTokenSource> {
  private apiClientFactory: ApiClientFactory;

  // api routes
  private CONSIGNMENT_ROUTE = "/admin/consignment";

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClientFactory = apiClientFactory;
  }

  buildFilter = (filter: PConsignmentFilter) => {
    return filter;
  };

  private getSignalToken(signal: CancelTokenSource) {
    return _.get(signal, "token", null);
  }

  private getError(error: any) {
    return _.get(error, "response.data.errors", "Something went wrong.");
  }

  async getConsignment(
    pagination: IPagination,
    filter: PConsignmentFilter,
    sorts: ISort<EConsignmentSortField>[],
    signal?: CancelTokenSource
  ): Promise<[IConsignment[], IMeta]> {
    const sort = buildSort(sorts);
    const params = _.pickBy(
      {
        ...pagination,
        ...this.buildFilter(filter),
      },
      Boolean
    );
    const [err, response] = await goPromise(
      this.apiClientFactory({ cancelToken: this.getSignalToken(signal) }).get(
        `${this.CONSIGNMENT_ROUTE}?sort=${sort}`,
        {
          params,
        }
      )
    );
    if (err) {
      throw this.getError(err);
    }
    const { data, meta } = response.data;
    return [data, meta];
  }

  async getConsignmentById(id: number): Promise<IConsignment> {
    const [err, response] = await goPromise(
      this.apiClientFactory().get(`${this.CONSIGNMENT_ROUTE}/${id}`)
    );
    if (err) {
      throw this.getError(err);
    }
    return response.data;
  }

  async approveConsignment(id: number): Promise<void> {
    const [err] = await goPromise(
      this.apiClientFactory().post(`${this.CONSIGNMENT_ROUTE}/${id}/approve`)
    );
    if (err) {
      throw this.getError(err);
    }
  }

  async rejectConsignment(id: number, rejected_reason: string): Promise<void> {
    const [err] = await goPromise(
      this.apiClientFactory().post(`${this.CONSIGNMENT_ROUTE}/${id}/reject`, {
        rejected_reason,
      })
    );
    if (err) {
      throw this.getError(err);
    }
  }
}
